import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslocoModule } from '@jsverse/transloco';
import { EntidadeConfiguracao, ExibicoesConfiguracoes } from 'app/interfaces';
import { ConfiguracoesService } from 'app/services';
import { map, Observable, timer } from 'rxjs';

interface SnackbarData {
  message: string;
  subtext: string;
  duration: number;
  type: string;
  imei?: string;
  entidadesConfiguracoes?: string[];
  configuracoesPendentes?: Record<string, ExibicoesConfiguracoes>;
}

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [MatProgressBar, CommonModule, TranslocoModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.css'
})
export class SnackbarComponent implements OnInit {
  public progresso$!: Observable<number>;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    public snackRef: MatSnackBarRef<SnackbarComponent>,
    private configuracoesService: ConfiguracoesService
  ) {}

  ngOnInit(): void {
    this.iniciarTimerNotificacao();
  }

  public onClick(): void {
    if (!this.data.imei && !this.data.entidadesConfiguracoes) return;

    if (this.data.type === 'info') {
      this.exibirConfiguracoesRecebidas();
    } else if (this.data.type === 'sucesso') {
      this.exibirConfiguracoesPendentes();
    }
  }

  private exibirConfiguracoesRecebidas(): void {
    if (!this.data.entidadesConfiguracoes || this.data.entidadesConfiguracoes.length === 0) return;

    let exibicoes: Record<string, ExibicoesConfiguracoes> = {};

    this.data.entidadesConfiguracoes.forEach(entidade => {
      exibicoes[entidade] = this.configuracoesService.obterConfiguracaoDeExibicaoPorEntidade(entidade as EntidadeConfiguracao)
    });

    this.mostrarConfiguracoesNaTela(exibicoes);
  }

  private exibirConfiguracoesPendentes(): void {
    this.mostrarConfiguracoesNaTela(this.data.configuracoesPendentes || {});
  }

  private mostrarConfiguracoesNaTela(configs: Record<string, ExibicoesConfiguracoes>): void {
    const titulo = this.data.type === 'info' ? 'Detalhes do Recebimento' : 'Envios pendentes';
    this.configuracoesService.abrirModalConfiguracoes(titulo, configs, this.data.type);
  }

  public iniciarTimerNotificacao(): void {
    const duracao = this.data.duration;
    const intervalo = 100;
    const steps = duracao / intervalo;

    this.progresso$ = timer(0, intervalo).pipe(
      map(i => Math.min(100, (i / steps) * 100))
    );

    timer(duracao).subscribe(() => this.snackRef.dismiss());
  }
}
